const CreatePolicyButton = ({ onClick=doesNothing }) => (
  <button
    type="button"
    className="btn btn-default waves-effect shadow-none"
    onClick={onClick}
  >
    <i className="material-icons">add_circle</i>
    <span>Add Policy...</span>
  </button>
);

export const ActionsRow = ({doCreatePolicy=doesNothing}) =>
  <div className="row margin-t-5 margin-b-0 margin-l-0">
    <CreatePolicyButton onClick={doCreatePolicy} />
  </div>